import { ILastState } from '../../state/types';
import { makeFetch } from './_shared/fetchMakers';
import { normalizeAndTranslateSingleEntity } from './_shared/normalizers';
import { makeLastStateUrl } from './_shared/urlMakers';

export const fetchLastState = makeFetch<ILastState>(
    makeLastStateUrl,
    normalizeAndTranslateSingleEntity
);
